import React, { useState, useContext } from "react";
import { Button, Form, Table } from "react-bootstrap";
import helpers from "../../utils/helpers";

import { capitalize } from "lodash";

import obj, { headerDataBetHistory } from "../../utils/constants";
import moment from "moment";
import DatePicker from "react-datepicker";

export const BettingHistoryTab = ({
  filter,
  setFilter,
  data,
  getData,
  betType,
}) => {
  const [active, setActive] = useState([]);
  return (
    <div className="common-container">
      <div className="inner-wrapper">
        <Form className="bet_status bettinghistory">
          <div className="d-flex align-items-center">
            <div className="bet-sec" style={{ marginRight: "6px" }}>
              <Form.Label className="mb-0">Bet Status</Form.Label>
              <Form.Select
                className="small_select"
                style={{ minWidth: "120px" }}
                onChange={(e) =>
                  setFilter({ ...filter, status: e.target.value })
                }
                value={filter.status}
                aria-label="Default select example"
              >
                <option value="">Matched</option>
                <option value="completed">Settled</option>
                <option value="suspend">Cancelled</option>
                <option value="voided">Voided</option>
              </Form.Select>
            </div>

            <div
              className="bet-sec bet-period bettinghistory-tab"
              style={{ marginRight: "6px" }}
            >
              <Form.Label className="mb-0" style={{ marginBottom: "7px" }}>
                Period
              </Form.Label>
              <Form.Group className="form-group">
                <DatePicker
                  className="small_form_control"
                  selected={filter.fromPeriod ? filter.fromPeriod : null}
                  onChange={(date) =>
                    setFilter({
                      ...filter,
                      fromPeriod: date,
                      filterByDay: "",
                    })
                  }
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                  placeholderText="Select a date"
                  onFocus={(e) => e.target.blur()}
                />
                <Form.Control
                  style={{ marginLeft: "4px" }}
                  className="small_form_control"
                  type="text"
                  placeholder="09:00"
                  disabled
                />
              </Form.Group>
            </div>

            <div className="bet-sec bet-period">
              <Form.Label
                style={{ marginRight: "2px", marginBottom: `0px` }}
                className="mb-0"
              >
                to
              </Form.Label>
              <Form.Group className="form-group">
                <DatePicker
                  className="small_form_control"
                  selected={filter.toPeriod ? filter.toPeriod : null}
                  onChange={(date) =>
                    setFilter({
                      ...filter,
                      toPeriod: date,
                      filterByDay: "",
                    })
                  }
                  dateFormat="yyyy-MM-dd"
                  minDate={
                    filter?.fromPeriod
                      ? new Date(filter?.fromPeriod).toISOString().split("T")[0]
                      : new Date()
                  }
                  maxDate={new Date().toISOString().split("T")[0]}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                  placeholderText="Select a date"
                  onFocus={(e) => e.target.blur()}
                />
                <Form.Control
                  style={{ marginLeft: "4px", width: "47px" }}
                  className="small_form_control"
                  type="text"
                  placeholder="08:59"
                  disabled
                />
              </Form.Group>
            </div>
          </div>
          <div className="history-btn mt-2">
            <ul className="list-unstyled mb-0">
              <li>
                <Button
                  className={"me-0 theme_light_btn"}
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      filterByDay: "today",
                    })
                  }
                  style={{ padding: `0 10px`, lineHeight: `25px` }}
                >
                  Just For Today
                </Button>
              </li>
              <li>
                <Button
                  className={"me-0 theme_light_btn"}
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      filterByDay: "yesterday",
                    })
                  }
                  style={{ padding: `0 10px`, lineHeight: `25px` }}
                >
                  From Yesterday
                </Button>
              </li>
              <li>
                <Button className="theme_dark_btn" onClick={() => getData()}>
                  Get History
                </Button>
              </li>
            </ul>
          </div>
        </Form>
      </div>
      {data?.data?.length == 0 ? (
        <div id="noReportMessage">
          <p className="p-0" style={{ marginBottom: "7px" }}>
            Betting History enables you to review the bets you have placed.{" "}
            <br />
            Specify the time period during which your bets were placed, the type
            of markets on which the bets were placed, and the sport.
          </p>
          <p className="p-0" style={{ marginBottom: "7px" }}>
            Betting History is available online for the past 62 days.
          </p>
          <p className="p-0" style={{ marginBottom: "7px" }}>
            User can search up to 14 days records per query only .
          </p>
        </div>
      ) : (
        <div className="account-table batting-table profit_loss_table betting-historytabl">
          <div className="responsive table-main-wrapper">
            <Table className="table_caption_style ">
              <thead>
                <tr>
                  {headerDataBetHistory.map((res) => {
                    return (
                      <th scope="col" className={res.class} width={res.widht}>
                        {res.title}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {data?.data?.length > 0 ? (
                  data?.data?.map((item) => {
                    return (
                      <>
                        <tr>
                          <td>
                            <span
                              style={{
                                color: "#2789ce",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {active.includes(item?._id) ? (
                                <img
                                  style={{
                                    height: "15px",
                                    marginRight: "5px",
                                  }}
                                  onClick={() =>
                                    setActive((prev) => {
                                      return prev?.filter((res) => {
                                        return res !== item?._id;
                                      });
                                    })
                                  }
                                  src={require("../../assets/images/expand-open.png")}
                                />
                              ) : (
                                <img
                                  style={{
                                    height: "15px",
                                    marginRight: "5px",
                                  }}
                                  onClick={() =>
                                    setActive((prev) => {
                                      return [...prev, item?._id];
                                    })
                                  }
                                  src={require("../../assets/images/expand-close.png")}
                                />
                              )}{" "}
                              {item?.matchBetId || item?.sessionBetId}
                            </span>
                          </td>
                          <td>{item?.clientName}</td>
                          <td className="text-start" width="30%">
                            <span style={{ textTransform: "uppercase" }}>
                              {obj.betCheckObj[item?.eventType]}
                            </span>
                            <img
                              class="fromto"
                              src={require("../../assets/images/transparent.gif")}
                            />
                            <strong>{item?.matchName}</strong>
                            <img
                              class="fromto"
                              src={require("../../assets/images/transparent.gif")}
                            />
                            {capitalize(item?.betFaireType) || item?.fancyName}
                          </td>
                          <td className="text-end">
                            {" "}
                            {betType === "fancy"
                              ? item?.betRun + "/" + item?.bhav
                              : betType === "sportBook"
                              ? item?.runnerName
                              : item?.teamName}
                          </td>
                          <td className="text-end">
                            {" "}
                            <span
                              className={
                                item?.betType == "lay" || item?.type == "No"
                                  ? "lay-bg"
                                  : item?.betType == "back" ||
                                    item?.type == "Yes"
                                  ? "back-bg"
                                  : ""
                              }
                              style={{ textTransform: "capitalize" }}
                            >
                              {item?.betType || item?.type}
                            </span>
                          </td>
                          <td className="text-end">
                            {moment(item?.timeInserted).format(
                              "YYYY-MM-DD hh:mm:ss"
                            )}
                          </td>
                          {/* <td className="text-end">
                                {" "}
                                {item?.matchBetId || item?.sessionBetId}
                              </td> */}
                          <td className="text-end">
                            {" "}
                            {filter.betType === "fancy"
                              ? item?.betRun + "/" + item?.bhav
                              : item?.bhav || "N/A"}
                          </td>{" "}
                          <td className="text-end">
                            {" "}
                            {helpers.currencyFormat(item?.amount) || "0.00"}
                          </td>
                          <td className="text-end">
                            {" "}
                            {filter.betType === "fancy"
                              ? item?.betRun + "/" + item?.bhav
                              : item?.bhav || "N/A"}{" "}
                          </td>
                          {item?.isDeclared ? (
                            filter.betType == "betfair" ||
                            filter.betType == "Bookmaker" ||
                            filter.betType == "toss" ||
                            filter.betType == "tie" ? (
                              <td className="text-end">
                                {(item?.teamSelectionWin == item?.selectionId &&
                                  item?.betType == "back") ||
                                (item?.teamSelectionWin != item?.selectionId &&
                                  item?.betType == "lay") ? (
                                  <span className="">
                                    {helpers.currencyFormat(
                                      item?.profitAmount.toFixed(2)
                                    )}
                                  </span>
                                ) : (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      item?.loseAmount.toFixed(2)
                                    )}
                                    )
                                  </span>
                                )}
                              </td>
                            ) : filter.betType === "sportsbook" ? (
                              <td className="text-end">
                                {item?.teamSelectionWin &&
                                item?.teamSelectionWin
                                  .split(",")
                                  .includes(item?.fancySelectionId) ? (
                                  <span className="">
                                    {helpers.currencyFormat(
                                      item?.profitAmount.toFixed(2)
                                    )}
                                  </span>
                                ) : (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      item?.loseAmount.toFixed(2)
                                    )}
                                    )
                                  </span>
                                )}
                              </td>
                            ) : (
                              <td className="text-end">
                                {item?.type == "No" ? (
                                  item?.decisionRun < item?.betRun ? (
                                    <span className="">
                                      {helpers.currencyFormat(
                                        item?.profitAmount.toFixed(2)
                                      )}
                                    </span>
                                  ) : (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        item?.loseAmount.toFixed(2)
                                      )}
                                      )
                                    </span>
                                  )
                                ) : item?.decisionRun >= item?.betRun ? (
                                  <span className="">
                                    {helpers.currencyFormat(
                                      item?.profitAmount.toFixed(2)
                                    )}
                                  </span>
                                ) : (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      item?.loseAmount.toFixed(2)
                                    )}
                                    )
                                  </span>
                                )}
                              </td>
                            )
                          ) : (
                            <td className="text-end">
                              <span>Not Settled</span>
                            </td>
                          )}
                        </tr>
                        {active.includes(item?._id) && (
                          <tr
                            className="expand new-bethistory-slip"
                            id={item?._id}
                          >
                            <td
                              style={{ background: "#e2e8ed" }}
                              colSpan={"2"}
                            ></td>
                            <td
                              colSpan="9"
                              style={{ background: "#e2e8ed" }}
                              className="new-bethistory-slip-td"
                            >
                              <img
                                class="expand-arrow"
                                src={require("../../assets/images/transparent.gif")}
                              ></img>
                              <table>
                                <tbody>
                                  <tr>
                                    <th>Bet Taken</th>
                                    <th>Odds req.</th>
                                    <th>Stake</th>
                                    <th>Liability</th>
                                    <th>Odds Matched</th>
                                  </tr>
                                  <tr
                                    id="txRow0"
                                    style={{ display: "table-row" }}
                                    className="even"
                                  >
                                    <td className="text-end">
                                      {" "}
                                      {moment(item?.timeInserted).format(
                                        "YYYY-MM-DD hh:mm:ss"
                                      )}
                                    </td>
                                    <td className="text-end">
                                      {" "}
                                      {filter.betType === "fancy"
                                        ? item?.betRun + "/" + item?.bhav
                                        : item?.bhav || "N/A"}
                                    </td>{" "}
                                    <td className="text-end">
                                      {" "}
                                      {helpers.currencyFormat(
                                        Number(item?.amount).toFixed(2)
                                      ) || "0.00"}
                                    </td>
                                    <td className="text-end">
                                      <span className="text-danger">
                                        (
                                        {helpers.currencyFormat(
                                          Number(item?.loseAmount).toFixed(2)
                                        )}
                                        )
                                      </span>
                                    </td>
                                    <td className="text-end">
                                      {" "}
                                      {filter.betType === "fancy"
                                        ? item?.betRun + "/" + item?.bhav
                                        : item?.bhav || "N/A"}
                                    </td>{" "}
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="12" className="text-end">
                      <span>You have no bets in this time period.</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {/* {data?.data?.length > 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                pageCount={pageCount}
                viewpage={viewpage}
              />
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};
